if (!customElements.get('sticky-component')) {
  class StickyComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Find the parent Shopify section element (like .section-header)
      this.section = this.closest('[id^="shopify-section-"]');
      
      if (!this.section) {
        console.warn('StickyComponent: Could not find parent Shopify section element');
        return;
      }

      this.sectionIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-size';
      this.sectionBounds = {};

      this.setSectionHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setSectionHeight.bind(this));

      if (this.sectionIsAlwaysSticky) {
        this.section.classList.add('wls-shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideSectionOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventComponentReveal', this.hideSectionOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setSectionHeight() {
      if (!this.section) return;
      document.documentElement.style.setProperty('--sticky-component-height', `${this.section.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventComponentReveal', this.hideSectionOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.section) return;
      
      let observer = new IntersectionObserver((entries, observer) => {
        this.sectionBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.section);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
      if (!this.section) return;
    
      if (scrollTop > this.sectionBounds.bottom) {
        // Always keep header sticky and visible when scrolled past
        this.section.classList.add('wls-scrolled-past-header', 'wls-shopify-section-header-sticky');
        this.section.classList.remove('wls-shopify-section-header-hidden');
      } else if (scrollTop <= this.sectionBounds.top) {
        // Reset when at top of page
        this.section.classList.remove('wls-scrolled-past-header', 'wls-shopify-section-header-hidden', 'wls-shopify-section-header-sticky', 'animate');
      }
    
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.sectionIsAlwaysSticky || !this.section) return;
      this.section.classList.add('wls-shopify-section-header-hidden', 'wls-shopify-section-header-sticky');
    }

    reveal() {
      if (this.sectionIsAlwaysSticky || !this.section) return;
      this.section.classList.add('wls-shopify-section-header-sticky', 'animate');
      this.section.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.sectionIsAlwaysSticky || !this.section) return;
      this.section.classList.remove('wls-shopify-section-header-hidden', 'wls-shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-component', StickyComponent);
}